import React from "react";
import logo from '../../components/logo/srma-logo.webp';
import '../../../src/pages/Website/webStyle.css'
import WebsiteNavbar from "./Navbar";
import instaOutline from '../../components/icons/instagram-ot.png';
import fbOutline from '../../components/icons/facebook-ot.png';
import ytOutline from '../../components/icons/youtube-ot.png';


export default function Footer() {

    return (
        <div>
            {/*Footer section */}
            <div className="footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8">
                            <h5>ABOUT SRMA</h5>
                            <p className="mt-4">SRMA (Singara Garden Ready Made Merchants Association) was established in 2007 to support over a thousand surplus garment manufacturers and traders. The association continues to be a strong backbone for the business community, providing leadership, support, and unity among traders.</p>
                        </div>
                        <div className="col-lg-2">
                            <div>
                                <h5>CONTACT US</h5>
                                <div className="mt-4">
                                    <p className="mb-2">+91 9876543210</p>
                                    <p>srma@gmail.com</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-2">
                            <div>
                                <h5>FOLLOW US ON</h5>
                                <div className="d-flex align-items-center mt-4">
                                    <img src={instaOutline} width='15%' />
                                    <img src={fbOutline} width='15%' className="followUsimg" />
                                    <img src={ytOutline} width='15%' className="followUsimg" />
                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/*Copyrights section */}
            <div className="copyrights">
                <p className="text-center">© 2025 SRMA | All Rights Reserved | Design by Digital Triumph</p>
            </div>

        </div>
    )
}